export const formatWithFixedTwoDecimals = (value: number | string): string => {
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numValue) || !isFinite(numValue)) {
    return "0.00";
  }

  return numValue.toFixed(2);
};

export const formatCurrency = (value: number | string): string => {
  return `₹${formatWithFixedTwoDecimals(value)}`;
};

export const formatCurrencyWithoutSymbol = (value: number | string): string => {
  return formatWithFixedTwoDecimals(value);
};

export const formatPercentage = (value: number | string): string => {
  return `${formatWithFixedTwoDecimals(value)}%`;
};

export const formatCurrencyWithLocalString = (
  value: number | string,
  decimalPlaces: number = 2,
): string => {
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue) || !isFinite(numValue)) return "₹0.00";

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(numValue);
};

const getFormatter = (decimalPlaces: number) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

export const formatCurrencyWithoutSymbolWithLocalString = (
  value: number | string | null | undefined,
  decimalPlaces: number = 2,
): string => {
  const numValue =
    typeof value === "string" ? parseFloat(value) : (value ?? NaN);
  if (!Number.isFinite(numValue)) {
    return getFormatter(decimalPlaces).format(0);
  }
  return getFormatter(decimalPlaces).format(numValue);
};
export const formatWithLocalString = (value: number | string): string => {
  const numValue = typeof value === "string" ? parseInt(value) : value;
  if (isNaN(numValue) || !isFinite(numValue)) return "0";

  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numValue);
};

export const formatPercentageWithLocalString = (
  value: number | string,
): string => {
  return `${formatCurrencyWithoutSymbolWithLocalString(value)}%`;
};

export const formatIndianCurrencyWithSign = (
  value: number | undefined | null,
  forceSign: boolean = true,
): string => {
  if (value === undefined || value === null) value = 0;

  if (typeof value === "string") {
    value = parseFloat(value);
  }

  if (isNaN(value) || Math.abs(value) < 0.01) return "₹0.00";

  const isPositive = value >= 0;
  const absValue = Math.abs(value);
  const sign = isPositive ? "+" : "-";
  let formattedValue = "";

  const trimDecimal = (num: number) => num.toFixed(2).replace(/\.?0+$/, "");

  if (absValue >= 10000000) {
    // Crore (Cr)
    formattedValue = trimDecimal(absValue / 10000000) + " Cr";
  } else if (absValue >= 100000) {
    // Lakh (L)
    formattedValue = trimDecimal(absValue / 100000) + " L";
  } else if (absValue >= 1000) {
    // Thousand (k)
    formattedValue = trimDecimal(absValue / 1000) + " K";
  } else {
    // Less than 1000
    formattedValue = trimDecimal(absValue);
  }

  if (forceSign) {
    return `${sign}₹${formattedValue}`;
  } else {
    return `${isPositive ? "" : "-"}₹${formattedValue}`;
  }
};
